import type { ActionModel } from '../types/action.model';

const ACTION_ACCEPTED_STATUS_LIST = ['completed', 'accepted', 'fully_accepted', 'auto_completed'];

export const isAccepted = (status: string) => ACTION_ACCEPTED_STATUS_LIST.includes(status);

export const isDeclined = (status: string) =>
	status === 'declined' ||
	status === 'fully_declined' ||
	status === 'auto_declined' ||
	status === 'rejected';

export const filterByStatus = (actions: ActionModel[], filterStatus: string) => {
	if (filterStatus === 'accepted') {
		return actions.filter((action) => isAccepted(action.status ?? ''));
	} else if (filterStatus === 'declined') {
		return actions.filter((action) => isDeclined(action.status ?? ''));
	} else if (filterStatus === 'no-response') {
		return actions.filter(
			(action) => !isAccepted(action.status ?? '') && !isDeclined(action.status ?? '')
		);
	}

	return actions;
};
